import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * アニメーション関連 Class
 */
export default class Animation {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
    this.setAnimation();
  };
  setAnimation() {
    let configPC = {
      start: 'top 80%',
      end: 'bottom 20%',
      toggleClass: 'is-animation',
      once: true
    };
    let configSP = {
      start: 'top 90%',
      end: 'bottom 10%',
      toggleClass: 'is-animation',
      once: true
    };

    ScrollTrigger.matchMedia({
      // 751px以上
      '(min-width: 751px)': function () {
        ScrollTrigger.batch('.js-fadeinup-large', configPC);
        ScrollTrigger.batch('.js-fadeinup-middle', configPC);
        ScrollTrigger.batch('.js-fadeinup-small', configPC);
        ScrollTrigger.batch('.js-fadeinup-small-osaka', configPC);
        ScrollTrigger.batch('.js-fadeinleft', configPC);
        ScrollTrigger.batch('.js-fadeinright', configPC);
        ScrollTrigger.batch('.js-fadeinup-list', configPC);
      },

      // 750px以下
      '(max-width: 750px)': function () {
        ScrollTrigger.batch('.js-fadeinup-large', configSP);
        ScrollTrigger.batch('.js-fadeinup-middle', configSP);
        ScrollTrigger.batch('.js-fadeinup-small', configSP);
        ScrollTrigger.batch('.js-fadeinup-small-osaka',configSP);
        ScrollTrigger.batch('.js-fadeinleft', configSP);
        ScrollTrigger.batch('.js-fadeinright', configSP);
        ScrollTrigger.batch('.js-fadeinup-list', configSP);
      }
    });
  }
}
